import React, {useEffect, useState} from "react";
import {setSimulateurObject} from "../../../actions/simulateur.action";
import {useDispatch} from 'react-redux';
import {styles} from "../../../stylesheets/simulateurs.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import ButtonArchivage from "../../../components/buttons/button.archivage";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";

// certificat de propriété
// simulateur Id 43

function Simulateur_ASimmo1(props, simulateur, isParent, departements) {
    const dispatch = useDispatch();

    let currUser = JSON.parse(localStorage.getItem("efluser"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")){
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

    const [departement, setDepartement] = useState(0)
    const [archivage, setArchivage] = useState(0)
    const [valeur_transmise, setValeurTransmise] = useState(0)
    const [nombre_page, setNombrePages] = useState(0)

    const handleChange = async (setter, value) => {
        if (setter === setDepartement) {
            setDepartement(parseInt(value))
        } else setter(value);
        setInRedux(setter, value)
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

    function setInRedux(setter, value) {
        if (props.isParent) {

            let object = {
                "simulateurid": props.simulateur.id,
                "departementid": 0,
                "bureauid": parseInt(currUser.id),
                "inputs": {}
            };

            if (setter === setDepartement) {
                Object.assign(object['inputs'], {'option_archivage': parseInt(archivage)})
                Object.assign(object['inputs'], {'valeur_transmise': parseInt(valeur_transmise)})
                Object.assign(object['inputs'], {'nombre_page': parseInt(nombre_page)})
                object.departementid = parseInt(value)
            }

            if (setter === setArchivage) {
                Object.assign(object['inputs'], {'option_archivage': parseInt(value)})
                Object.assign(object['inputs'], {'valeur_transmise': parseInt(valeur_transmise)})
                Object.assign(object['inputs'], {'nombre_page': parseInt(nombre_page)})
                object.departementid = parseInt(departement)
            }

            if (setter === setValeurTransmise) {
                Object.assign(object['inputs'], {'option_archivage': parseInt(archivage)})
                Object.assign(object['inputs'], {'valeur_transmise': parseInt(value)})
                Object.assign(object['inputs'], {'nombre_page': parseInt(nombre_page)})
                object.departementid = parseInt(departement)
            }

            if (setter === setNombrePages) {
                Object.assign(object['inputs'], {'option_archivage': parseInt(archivage)})
                Object.assign(object['inputs'], {'valeur_transmise': parseInt(valeur_transmise)})
                Object.assign(object['inputs'], {'nombre_page': parseInt(value)})
                object.departementid = parseInt(departement)
            }

            dispatch(setSimulateurObject(object));

        } else {

            // process child simu

        }
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>

                <TextfieldRemarques handleChange={handleChangeRemarque}/>

                <p style={styles.cardSubTitle}>
                Acte tarifé au titre du Tableau 5, n° 47.
                </p>

                {props?.isParent === true && props.departements !== "" ?
                    <div style={styles.cardRow}>
                        <div style={styles.cardElemVerticalyCenter}>
                            Département :
                        </div>

                        <SelectDepartement items={props.departements} nameField={"name"} defaultValue={currUserDep} optionValue={"id"}
                                      handleChange={handleChange} setter={setDepartement}/>
                    </div>
                    :
                    <></>
                }

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Option d’archivage
                    </div>
                    <ButtonArchivage handleChange={handleChange} setter={setArchivage} defaultValue={1}/>
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Quelle est la valeur transmise ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer la valeur"}
                        setter={setValeurTransmise}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Nombre de page(s) de l’acte ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le nombre de pages"}
                        setter={setNombrePages}
                    />
                </div>

            </div>

        </div>
    )
}

export default Simulateur_ASimmo1;
